import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

interface LoadingFallbackProps {
  message?: string;
  size?: number;
}

const LoadingFallback: React.FC<LoadingFallbackProps> = ({
  message = "Cargando...",
  size = 60,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "calc(100dvh - 64px)",
        bgcolor: "background.default",
        p: 3,
      }}
    >
      <CircularProgress size={size} color="primary" sx={{ mb: 2 }} />
      <Typography variant="h6" color="text.secondary">
        {message}
      </Typography>
    </Box>
  );
};

export default LoadingFallback;
